import { ArrowRight } from 'lucide-react';
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary';
  withArrow?: boolean;
}

export default function Button({ 
  children, 
  variant = 'primary', 
  withArrow = false,
  className = '',
  ...props 
}: ButtonProps) {
  const baseStyles = "px-6 py-3 rounded-lg font-medium transition-colors";
  const variants = {
    primary: "bg-brown-600 hover:bg-brown-700 text-white",
    secondary: "bg-white hover:bg-gray-50 text-brown-600 border border-brown-600"
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${className}`}
      {...props}
    >
      <span className="flex items-center">
        {children}
        {withArrow && <ArrowRight className="ml-2" />}
      </span>
    </button>
  );
}